module.exports = __webpack_public_path__ + "static/media/paclgh.31cd4003.png";